// import { DataSource } from 'ng2-smart-table/lib/lib/data-source/data-source';
import { Observable } from 'rxjs';
import { has, isNil, isObject, isString, find, isEmpty,  } from 'lodash';

import { DataSource, ServerDataSource } from 'angular2-smart-table';
// import { ViewCell } from 'ng2-smart-table';
import { Model } from './common/.base.model';
import { Person } from './person';
import { DatePipe } from '@angular/common';
import { EntityConfigTemplate } from './common/entity-config.interface';
import { FormConfigTemplate } from './common/form-config-template.interface';

const dPipe = new DatePipe('en-US');
export interface Training extends Model {
  title: string;
  description?: string;
  date?: Date;
  durationHours?: number;
  provider?: string;
  attendees?: Person[];
}

export interface TrainingResult extends Model {
  person?: Person;
  training?: Training;
  result?: string;
  remarks?: string;
  completedAt?: Date;
}

export const TrainingConfig: EntityConfigTemplate = {
  meta: { entityName: 'training', entityPluralName: 'trainings', titleField: 'title', view: false },
  title: { title: 'Title' },
  description: { title: 'Description' },
  date: { title: 'Date', type: 'date', valuePrep: (cell: Date, _: any) => dPipe.transform(cell, 'MMM dd, yyyy'), },
  durationHours: { title: 'Duration (Hours)', type: 'number' },
  provider: { title: 'Provider' },
  attendees: { isForeignKey: true, title: 'Attendees', valuePrep: (_cell_, row) => `${row?.attendees?.length | 0}` },
};

export const TrainingResultConfig: EntityConfigTemplate = {
  meta: { entityName: 'trainingResult', entityPluralName: 'trainingResults', titleField: 'person', view: false, attachedToField: 'person'  },
  person: { isForeignKey: true, title: 'Person', valuePrep: (_cell_, row) => `${row?.person?.firstName ?? ''} ${row?.person?.lastName ?? ''}`, view: false },
  training: { isForeignKey: true, type: 'relation', title: 'Training', valuePrep: (_cell_, row) => `${row?.training?.title ?? ''}` },
  result: { title: 'Result' },
  remarks: { title: 'Remarks' },
  completedAt: { title: 'Completed At', type: 'date', valuePrep: (cell: Date, _: any) => dPipe.transform(cell, 'MMM dd, yyyy'), },
  followupDate: { title: 'Followup Date', type: 'date', valuePrep: (cell: Date, _: any) => dPipe.transform(cell, 'MMM dd, yyyy'), },
};

export const TrainingFormConfig: FormConfigTemplate = {
  tabs: [
    {
      title: "Training Details",
      columns: [
        {
          type: "form",
          size: "col-12",
          sections: [
            {
              title: "Overview",
              rows: [
                {
                  fields: [
                    { name: "title", label: "Title", type: "text", required: true, size: "col-3" },
                    { name: "date", label: "Date", type: "date", size: "col-3" },
                    { name: "durationHours", label: "Duration (Hours)", type: "number", size: "col-3" },
                    { name: "provider", label: "Provider", type: "text", size: "col-3" },
                  ]
                },
                {
                  fields: [
                    { name: "description", label: "Description", type: "textarea", size: "col-12" },
                  ]
                },
                {
                  fields: [
                    { name: "attendees", label: "Attendees", multiSelect:true,  type: "selectRelation", entityName:"person", size: "col-12" },
                  ]
                },
              ],
            }
          ],
        },
      ],
    },
  ],
}



export abstract class TrainingData {
  abstract get gridDataSource(): ServerDataSource;
  abstract list(pageNumber: number, pageSize: number): Observable<Training[]>;
  abstract listAll(): Observable<Training[]>;
  abstract get(id: string): Observable<Training>;
  abstract update(record: Training): Observable<Training>;
  abstract create(record: Training): Observable<Training>;
  abstract delete(id: string): Observable<boolean>;
}

export abstract class TrainingResultData {
  abstract get gridDataSource(): ServerDataSource;
  abstract list(pageNumber: number, pageSize: number): Observable<TrainingResult[]>;
  abstract listAll(): Observable<TrainingResult[]>;
  abstract get(id: string): Observable<TrainingResult>;
  abstract update(Department: TrainingResult): Observable<TrainingResult>;
  abstract create(Department: TrainingResult): Observable<TrainingResult>;
  abstract delete(id: string): Observable<boolean>;
}